const SSN_BLOCKLIST = [
  '123-45-6789',
  '111-11-1111',
  '222-22-2222',
  '333-33-3333',
  '444-44-4444',
  '555-55-5555',
  '777-77-7777',
  '888-88-8888',
  '666-66-6666',
  '999-99-9999',
  '000-00-0000',
];

export const formatSSN = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 5)
    return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5, 9)}`;
};

export const validateSSN = (ssnValue?: string): boolean => {
  if (!ssnValue) return false;

  const normalized = ssnValue.replace(/\D/g, '');
  if (normalized.length !== 9) return false;

  const formatted = `${normalized.slice(0, 3)}-${normalized.slice(3, 5)}-${normalized.slice(5, 9)}`;

  if (SSN_BLOCKLIST.includes(formatted)) return false;

  const ssnRegex = /^(?!000|666|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/;
  if (!ssnRegex.test(formatted)) return false;

  return true;
};
